// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const constants = {
    productList: {
        xSortAndFilter: {
            screen: "isTabletScreen",
            breakpoint: "md",
        },
    },
    cartLine: {
        breakpoints: {
            md: "1100",
            xs: "xs",
        },
    },
};

export const DivWrapper = `div[class^="Wrapper"]`;
export const XNGAGE_CUSTOM_WIDGET = "Xngage Custom" as any;
export const EMPTY_VALUE = "- -";
export const ErrorApiDefaultMessage = "Please try again and contact support if you continue to have issues.";
